import { SerieProposalService } from './../serie-proposal.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'

import moment from 'moment-mini'
import { Observable } from 'rxjs'
import { map, take, withLatestFrom } from 'rxjs/operators'

import { DatePipe } from '@angular/common'
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'
import { Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { AppState } from 'src/app/core/core.state'
import { Organization } from 'src/app/features/organization/organization'
import { organizationSelectors } from 'src/app/features/organization/organization.selectors'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { SerieProposal, SerieProposalStatus } from '../serie-proposal'
import { serieProposalItemSelectors } from '../serie-proposal-item/serie-proposal-item.selectors'
import { SerieProposalItem } from '../serie-proposal-item/serie-proposal-item'
import { MessageService } from 'src/app/features/message/message.service'

@UntilDestroy()
@Component({
  selector: 'serie-proposal-schedule',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss'],
  providers: [DatePipe]
})
export class SerieProposalScheduleComponent implements OnInit {
  @Input() serieProposals: SerieProposal[]
  @Input() selectedProductIds: any[]
  @Input() selectedDay: moment.Moment
  @Input() dependantProductsMap: { [key: number]: number[] } = {}

  @Output() onClickSerieProposal: EventEmitter<any> = new EventEmitter()

  public productEntities$: Observable<Dictionary<Product>>
  public organizationEntities$: Observable<Dictionary<Organization>>
  public serieProposalItemEntities$: Observable<Dictionary<SerieProposalItem>>
  public productEntities: Dictionary<Product>
  public renderCalcul = false
  public currentStartDate: Date
  public currentEndDate: Date
  public serieProposalStatus = SerieProposalStatus
  public preProposalsForProductAndHour: { [key: number]: {} } = {}
  public hours: string[] = []

  constructor(
    private translate: TranslateService,
    private store: Store<AppState>,
    public messageService: MessageService,
    private serieProposalService: SerieProposalService
  ) {}

  ngOnInit() {
    this.serieProposalItemEntities$ = this.store.select(
      serieProposalItemSelectors.selectEntities
    )
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.organizationEntities$ = this.store.select(
      organizationSelectors.selectEntities
    )

    this.generateHours()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['serieProposals'] &&
      !changes['serieProposals'].isFirstChange()
    ) {
      this.renderCalcul = false
      if (this.serieProposals && this.serieProposals.length > 0) {
        this.getEarliestTime()
      }

      this.renderCalcul = true
    }
    if (changes['selectedDay'] && !changes['selectedDay'].isFirstChange()) {
      this.selectedDay = changes['selectedDay'].currentValue
      this.renderCalcul = false

      this.renderCalcul = true
    }
  }
  private getEarliestTime() {
    const mappedSerieProposals = []
    this.serieProposals.forEach((proposal) => {
      if (proposal.details.repeatableBookings?.length > 0) {
        proposal.details.repeatableBookings.map((it) =>
          mappedSerieProposals.push(it.startTime)
        )
      } else if (
        proposal.details.initialRequest.repeatableBookings?.length > 0
      ) {
        proposal.details.initialRequest.repeatableBookings.map((it) =>
          mappedSerieProposals.push(moment(it.startTime))
        )
      } else if (proposal.details.customBookings?.length > 0) {
        proposal.details.customBookings.map((it) =>
          mappedSerieProposals.push(moment(it.startDate).format('HH:mm:ss'))
        )
      } else if (proposal.details.initialRequest.customBookings?.length > 0) {
        proposal.details.initialRequest.customBookings.map((it) =>
          mappedSerieProposals.push(moment(it.startDate).format('HH:mm:ss'))
        )
      } else {
        mappedSerieProposals.push(moment(proposal.startDate).format('HH:mm:ss'))
      }
    })

    const earliestTime = mappedSerieProposals.reduce((earliest, current) => {
      return current < earliest || (current === earliest && current < earliest)
        ? current
        : earliest
    })

    if (earliestTime < '08:00:00') {
      this.generateHours(Number(earliestTime.split(':')[0]))
    }
  }

  private generateHours(earliestHour: number = 8) {
    this.hours = []
    for (let i = earliestHour; i <= 24; i++) {
      const hour = i < 10 ? `0${i}:00` : `${i}:00`
      this.hours.push(hour)
    }
  }

  public getHeight(proposal): string {
    const momentTime1 = moment(proposal.startTime, 'HH:mm:ss')
    const momentTime2 = moment(proposal.endTime, 'HH:mm:ss')

    const differenceInMinutes = momentTime2.diff(momentTime1, 'minutes')

    return `${Math.round((differenceInMinutes / 60) * 100)}%`
  }

  public getTop(proposal): string {
    const startMinutes = moment(proposal.startTime, 'HH:mm:ss').minutes()

    return `${Math.round((startMinutes / 60) * 100)}%`
  }

  public onSerieProposalClick(proposal) {
    if (proposal.blocked) return
    this.onClickSerieProposal.emit(proposal)
  }

  public getSerieProposalItems$(
    proposal: SerieProposal
  ): Observable<SerieProposalItem[]> {
    return this.store.select(serieProposalItemSelectors.selectByFilter, {
      field: 'serieProposalId',
      value: proposal.id
    })
  }
}
